import { render, staticRenderFns } from "./subjectType.vue?vue&type=template&id=020daaee&scoped=true&"
import script from "./subjectType.vue?vue&type=script&lang=js&"
export * from "./subjectType.vue?vue&type=script&lang=js&"
import style0 from "./subjectType.vue?vue&type=style&index=0&id=020daaee&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020daaee",
  null
  
)

export default component.exports